import script from "./PCMall.vue?vue&type=script&lang=ts&setup=true"
export * from "./PCMall.vue?vue&type=script&lang=ts&setup=true"

import "./PCMall.vue?vue&type=style&index=0&id=0466331d&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0466331d"]])

export default __exports__